import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'src/components';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { oneDayAgoDate, todayDate } from 'src/utils/dateOneMonthAgo';
import { formatDateTime } from '../kds';
import DateRangePickerWithTime from './test';
import { Tooltip } from '@mui/material';
import { Info } from '@phosphor-icons/react/dist/ssr';
import '../../index.css';
import AdminDashboard from '../back-office/Dashboard/Dashboard';
import { fetchSales } from 'src/redux/action/sales.action';
import { useDispatch } from 'react-redux';

const DailySummary = () => {
  const dispatch = useDispatch()
  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const businessName = settingData?.businessInfo?.name;
  const businessAddress = settingData?.businessInfo?.address;
  const pan = settingData?.businessInfo?.pan;
  const [data, setData] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>(oneDayAgoDate);
  const [endDate, setEndDate] = useState<any>(todayDate());
  const [dateQuery, setDateQuery] = useState<any>(
    `from=${startDate?.toISOString()}&to=${endDate?.toISOString()}`
  );

    
  // const [floors, setFloors] = useState<any>('');

  // floors=ad7afc99-f394-4dc1-bbc7-e9bdd124df61,476faf38-990e-4d78-8874-263f9a552e24

  const handlePrintReport = () => {
    const prtContent = document.getElementById(`daily-sales-print`);
    if (!prtContent) return;
    const printWindow = window.open(
      '',
      '',
      'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (printWindow) {
      printWindow.document.write(prtContent.innerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Failed to open a new window for printing.');
    }
  };

  const RenderMainDetails = (
    title: string,
    total: number,
    array: any[],
    tooltipInfo?: string,
    mainKey?: string,
    mainvalue?: string
  ) => {
    return (
      <div
        style={{
          paddingInline: '8px',
          marginTop: '4px',
        }}
      >
        <div
          style={{
            display: ' grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            fontSize: '14px',
          }}
        >
          <div
            style={{ gridColumn: 'span 3' }}
            className="flex items-center gap-1"
          >
            <span>{title}</span>
            {tooltipInfo && (
              <Tooltip className="no-print" title={tooltipInfo}>
                <Info />
              </Tooltip>
            )}
          </div>
          <span>{total}</span>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {array?.map((each: any, i: number) => {
            if (each.total === 0) return;
            if (!each.key) each.key = 'name';
            if (!each.value) each.value = 'amount';
            return (
              <div key={'render_details_' + each.id + i}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    fontSize: '12px',
                  }}
                >
                  <div
                    style={{
                      gridColumn: 'span 3',
                      textTransform: 'capitalize',
                      paddingLeft: '12px',
                    }}
                  >
                    • {mainKey ? each[mainKey] : each.id}
                  </div>
                  <div>{mainvalue ? each[mainvalue] : each.total}</div>
                </div>
                {/* creditors name */}
                {each.child &&
                  each.child.length > 0 &&
                  each.child?.map((eachCred: any, indCred: number) => (
                    <div
                      key={'cred_sales' + indCred}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        fontSize: '12px',
                        marginLeft: 10,
                      }}
                    >
                      <div
                        style={{
                          gridColumn: 'span 3',
                          textTransform: 'capitalize',
                          paddingLeft: '12px',
                        }}
                      >
                        • {eachCred[each.key]}
                      </div>
                      <div>{eachCred[each.value]}</div>
                    </div>
                  ))}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const RenderDetails = (array: any[]) => {
    return (
      <div
        style={{
          paddingInline: '8px',
          marginTop: '4px',
        }}
      >
        {array?.map((each: any, i: number) => {
          if (each.total === 0) return;
          return (
            <div
              key={'render_details_' + each.id + i}
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                fontSize: '14px',
              }}
            >
              <div
                style={{ gridColumn: 'span 3', textTransform: 'capitalize' }}
              >
                {each.id}
              </div>
              <div>{each.total}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const RenderBody = (start: any, end: any, data: any) => {
    return (
      <div id="daily-sales-print" className="text-black w-[300px]">
        <div>
          <div
            className="w-[100%] h-[100%]"
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontFamily: 'Arial',
              fontWeight: '400',
            }}
          >
            <div
              className="d-flex flex-column"
              style={{ fontFamily: 'Arial', fontWeight: '400' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    lineHeight: '18px',
                    marginBottom: '5px',
                    textTransform: 'uppercase',
                  }}
                >
                  {businessName}
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    marginBottom: '5px',
                    textTransform: 'uppercase',
                  }}
                >
                  {businessAddress?.area} {businessAddress?.city}
                </span>
                {pan && (
                  <span
                    style={{
                      fontSize: '12px',
                      lineHeight: '14px',
                      marginBottom: '5px',
                      textTransform: 'uppercase',
                    }}
                  >
                    PAN : {pan}
                  </span>
                )}
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    marginBottom: '5px',
                  }}
                >
                  DAILY SALES SUMMARY
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '15px',
                  gap: '8px',
                }}
              >
                <span>From: {formatDateTime(start)}</span>
                <span>To: {formatDateTime(end)}</span>
              </div>
              <div
                style={{
                  border: '1px solid #bec1ce',
                  marginTop: '1px',
                  borderRadius: '5px',
                  padding: '8px 0',
                }}
              >
                {RenderMainDetails(
                  'Gross sales',
                  data.grossSales,
                  data?.orderTypeSummaries
                )}
                {RenderDetails([{ id: 'Discount', total: data.discountTotal }])}
                <div
                  style={{
                    border: '1px solid #bec1ce',
                    borderTop: '0px',
                    margin: '8px 0',
                  }}
                />
                {RenderMainDetails(
                  'Net Sales',
                  data.netSales,
                  [
                    {
                      id: 'Credit Sales',
                      total: data.creditSales,
                      child: data.creditUserSummaries,
                      key: 'name',
                      value: 'amount',
                    },
                    { id: 'Non-credit Sales', total: data.nonCreditSales },
                  ],
                  'Gross sales - Discount'
                )}
                {RenderMainDetails(
                  'Credit Received',
                  data.creditReceived,
                  data.creditPaymentUserSummaries,
                  '',
                  'name',
                  'amount'
                )}
                {RenderMainDetails(
                  'Net Total',
                  data.totalReceived,
                  data?.paymentMethodSummaries,
                  'Credit Received + Non-credit sales'
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const fetchData = useCallback(async (querySend: string) => {
    try {
      const res = await Service.get(
        `/payments/receipt/sales/summary${querySend}`
      );
      const data = (await res?.data) ?? [];
      setData(data);
    } catch (err) {}
  }, []);

  useEffect(() => {
    fetchData(`?${dateQuery}&categories=${[]}`);
  }, [startDate, endDate]);

  return (
    <>
      <div className="pb-10 flex flex-col">
        <div className="flex items-center ml-auto">
          {/* {DateRangePickerWithTime(
            fetchData,
            [],
            setDateQuery,
            setStartDate,
            setEndDate
          )} */}
          <Button
            onClick={handlePrintReport}
            text="Print Report"
            className="ml-2"
          />
        </div>
        {/* <div className="border border-solid border-light-gray py-4 px-3 rounded-md w-fit mt-2 hidden">
          {RenderBody()}
        </div> */}
        <AdminDashboard renderBodyComp={RenderBody} />
      </div>
    </>
  );
};

export default DailySummary;
